import React from 'react';
import { Card, CardBody, CardHeader } from '@progress/kendo-react-layout';
import './CreateRolloutLoader.scss';

const renderRows = (count, className = '') =>
  Array.from({ length: count }, (_, index) => (
    <div
      key={`${className || 'row'}-${index}`}
      className={`create-rollout-loader__line ${className}`.trim()}
    />
  ));

const CreateRolloutLoader = () => {
  return (
    <div className="container mx-auto rollout-form-container create-rollout-loader">
      <div className="container add-page-section">
        <Card className="k-mt-3 detail-card">
          <CardBody className="detail-card-body">
            <div className="card-content rollout-form-card">
              <div className="account-form-wrapper">
                <div className="k-d-flex single-field-row single-row-100 create-rollout-loader__row">
                  <div className="k-p-2 field-wrapper k-w-100">
                    {renderRows(1, 'create-rollout-loader__label')}
                    {renderRows(1, 'create-rollout-loader__input')}
                  </div>
                  <div className="k-p-2 field-wrapper k-w-100">
                    {renderRows(1, 'create-rollout-loader__label')}
                    {renderRows(1, 'create-rollout-loader__input')}
                  </div>
                </div>
                <div className="k-d-flex single-field-row single-row-100 create-rollout-loader__row">
                  <div className="k-p-2 field-wrapper k-w-100">
                    {renderRows(1, 'create-rollout-loader__label')}
                    {renderRows(
                      1,
                      'create-rollout-loader__input create-rollout-loader__input--tall'
                    )}
                    {renderRows(1, 'create-rollout-loader__hint')}
                  </div>
                  <div className="k-p-2 field-wrapper k-w-100">
                    {renderRows(1, 'create-rollout-loader__label')}
                    <div className="create-rollout-loader__toggle-row">
                      {renderRows(1, 'create-rollout-loader__toggle-label')}
                      {renderRows(1, 'create-rollout-loader__toggle')}
                      {renderRows(1, 'create-rollout-loader__toggle-label')}
                    </div>
                  </div>
                </div>
                <div className="k-d-flex single-field-row single-row-100 create-rollout-loader__row">
                  <div className="k-p-2 field-wrapper k-w-100">
                    {renderRows(1, 'create-rollout-loader__label')}
                    {renderRows(1, 'create-rollout-loader__textarea')}
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
        <Card className="k-mt-3">
          <CardHeader>
            <div className="k-d-flex single-field-row button-form-wrapper k-action-buttons !k-px-0 k-float-right create-rollout-loader__actions">
              {renderRows(
                1,
                'create-rollout-loader__button create-rollout-loader__button--secondary'
              )}
              {renderRows(1, 'create-rollout-loader__button')}
            </div>
          </CardHeader>
        </Card>
      </div>
    </div>
  );
};

export default CreateRolloutLoader;
